import { GlobalLetter, InputField, SelectOption } from '../types';

interface ApiError {
  response?: {
    data?: {
      message?: string;
    };
  };
}

export const formatErrorMessage = (error: ApiError): string => {
  const message = error?.response?.data?.message || 'Failed to upload image';

  if (message.includes('AccessDenied') || message.includes('s3:PutObject')) {
    return 'Unable to upload image due to server permissions. Please contact support.';
  }

  if (message.includes('AWS HTTP error')) {
    return 'Unable to upload image. Please try again later.';
  }

  return message;
};

export const createSelectInput = (
  name: keyof GlobalLetter,
  options: SelectOption[] = [],
  label = '',
): InputField => ({
  type: 'select',
  label,
  options,
  name,
});
